<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vx-card>
      <div class="vx-row">
          <div class="vx-col mt-5">
          <h2 class="mb-2">Atualizar arquivo de remessa do banco</h2>
          </div>
      </div>
      <div class="vx-row">
        <div class="vx-col mt-5">
          <input
            multiple
            type="file"
            class="hidden"
            ref="attachmentInput"
            @change="attachFile()"
            accept="application/x-x509-ca-cert"
            name="file"
            v-validate="'required'"
          />

          <vs-button color="primary" @click="$refs.attachmentInput.click()">
            Selecione os arquivos
          </vs-button>
        </div>
      </div>
       <div class="vx-row">
        <div class="vx-col md:w-full mt-5">
          <vs-list v-if="file">
            <vs-list-item
              :title="file.name"
              :subtitle="file.type"
            ></vs-list-item>
          </vs-list>
        </div>
      </div>
      <span class="text-danger">{{ errors.first("file") }}</span>
      <div class="vx-row">
        <div class="vx-col md:w-full mt-5" v-if="showSaveButton">
          <vs-button class="float-right" color="success" @click="submit"
            >Salvar</vs-button
          >
          <vs-button class="float-left" color="warning" @click="clean"
            >Limpar</vs-button
          >
        </div>
      </div>
    </vx-card>
  </div>
</template>


<script>
import { Validator } from "vee-validate";
import { fileTools } from "@/helpers";
import axios from "axios";
import { baseApiUrl } from "@/global";
import router from "@/router";
import vSelect from "vue-select";
const dict = {
  custom: {
    file: {
      required: "Insira o Arquivo",
    },
  },
};

Validator.localize("en", dict);
export default {
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      customerSelected: [],
      currentAttachment: {},
      showSaveButton: false,
      fileTools: null,
      file: null,
      templateSelected: null,
    };
  },
  computed: {
   
  },
  methods: {
    async submit() {
      const haveErrors = !(await this.$validator.validateAll());
      if (haveErrors) return;
      
      try {
        this.$vs.loading();
        await axios.post(`${baseApiUrl}/invoice/bankReturn`, this.file);
        this.$vs.notify({
          title: "Salvo",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        router.push("/faturas/enviadas").catch(() => {});
     } catch (error) {
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
        this.file = {};
      }
    },

    async attachFile() {
      this.showSaveButton = true;
      let file = this.$refs.attachmentInput.files[0]
      let base64 = await this.fileTools.toBase64(this.$refs.attachmentInput.files[0]);
      file = {
          name: file.name,
          file: base64,
          type: file.type,
        };
        this.file = file

    },
    async clean() {
      this.file = {};
      this.showSaveButton = false;
    },
  },
  created() {
    this.fileTools = fileTools();
 
  },
};
</script>
 
